
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    Form
} from "reactstrap";
import ContentService from "../../../services/xgContentService";
import ContentForm from "./Form";
import {contentCategory} from "../../../util/contentCategory";
import {contentArticleType} from "../../../util/contentArticleType";
import {contentType} from "../../../util/contentType";
import _ from "lodash";
import UtilService from "../../../services/utilService";
import {value} from "lodash/seq";
import {ContentState, convertFromHTML, convertToRaw, EditorState} from "draft-js";
import draftToHtml from "draftjs-to-html";
import Loader from "../../Loader";
import imageDecorator from "../util/imageDecorator";

class ContentEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            selectKey: UtilService.uuidv4(),
            editorState: undefined,
            loading: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleIsPaidChange = this.handleIsPaidChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleArticleTypeChange = this.handleArticleTypeChange.bind(this);
        this.handleContentTypeChange = this.handleContentTypeChange.bind(this);
        this.handleContentChange = this.handleContentChange.bind(this);
    }

    async componentDidMount() {
        const {uniqueId} = this.props.match.params;
        const response = await ContentService.fetch(uniqueId)
        const category = response.data.category;
        const contentType = response.data.contentType;
        this.setState({selectedCategory : {key:category, value:category}, selectedContentType :{key:contentType, value:contentType}});
        const selArticleType =response.data.articleTypes && response.data.articleTypes.map(type => ({key : type, value : type}))
        this.setState({selectedArticleType : selArticleType});
        this.setState(response.data);
        this.setState({uniqueId: uniqueId});
        this.setState({selectKey: UtilService.uuidv4()});
        let contentTextHMTL = response.data.content || "";
        const blocksFromHTML = convertFromHTML(contentTextHMTL);
        const content = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap);
        this.setState({
            editorState: EditorState.createWithContent(content, imageDecorator)
        });
    }

    handleChange(event) {
        if(event.target.type === "checkbox") {
            this.setState({[event.target.name]: event.target.checked});
        } else{
            this.setState({[event.target.name]: event.target.value});
        }
    }

    handleIsPaidChange(event) {
        this.setState({[event.target.name]: event.target.checked});
    }

    handleContentChange(editorState) {
        this.setState({ editorState });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({loading: true});
        let data = {
            articleTypes : this.state.articleTypes,
            category : this.state.category,
            contentType: this.state.contentType,
            title : this.state.title,
            content:this.state.content,
            uniqueId : this.state.uniqueId,
            isPaidContent : this.state.isPaidContent,
        }
        if (this.state.selectedContentType.key === "TEXT") {
            const updatedContent = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
            // Use a callback to ensure state is updated before making the API call
            this.setState({content: updatedContent}, () => {
                data.content = this.state.content;
                data.seoText = this.state.seoText;
                ContentService.update(data).then(response => {
                    if (response.responseStatus === "SUCCESS") {
                        this.props.history.push("/crm/content/list");
                    } else {
                        this.setState({errorData: response.data});
                        console.error("Error    ==>     " + response.message);
                    }
                    this.setState({loading:false});
                });
            });
        } else {
            // If content type is not TEXT, proceed without modifying content
            data.seoText = this.state.seoText;
            ContentService.update(data).then(response => {
                if (response.responseStatus === "SUCCESS") {
                    this.props.history.push("/crm/content/list");
                } else {
                    this.setState({errorData: response.data});
                    console.error("Error    ==>     " + response.message);
                }
                this.setState({loading:false});
            });
        }
    }

    handleSelectChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedCategory: {}, category: ""});
        } else {
            this.setState({selectedCategory: valueObj, category: valueObj.key});
        }
    }

    handleArticleTypeChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedArticleType: []});
        } else {
            this.setState({selectedArticleType: valueObj});
            const keys = _.map(valueObj, "key")
            this.setState({articleTypes: keys});
        }
    };

    handleContentTypeChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedContentType:  [], contentType :""});
        } else {
            this.setState({selectedContentType: valueObj, contentType : valueObj.key});
        }
    };

    uploadImageCallback (file)  {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve({ data: { link: reader.result } });
            };
            reader.onerror = reject;
            reader.readAsDataURL(file); // Converts the file to a base64 URL
        });
    };


    render() {
        return (
            <>
                <SimpleHeader
                    name="Edit"
                    parentName="Content"
                    heading="XareGrowth"
                    newBtnUrl="/crm/content/create"
                    newBtnText="Create Content"
                />
                {this.state.loading && <Loader />}
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Edit Content</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ContentForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={true}
                                    selectKey={this.state.selectKey}
                                    contentCategories={contentCategory}
                                    onSelectChange={this.handleSelectChange}
                                    selectedCategory={this.state.selectedCategory}
                                    onArticleTypeChange={this.handleArticleTypeChange}
                                    selectedArticleType={this.state.selectedArticleType}
                                    articleTypes={contentArticleType}
                                    onContentTypeChange={this.handleContentTypeChange}
                                    selectedContentType={this.state.selectedContentType}
                                    contentTypes = {contentType}
                                    obj={this}
                                    uploadImageCallback = {this.uploadImageCallback}
                                    handleIsPaidChange = {this.handleIsPaidChange}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default ContentEdit;
